export const SET_PRODUCT = 'PARTNER/PRODUCT/SET_PRODUCT'
export const SET_PRODUCTS = 'PARTNER/PRODUCT/SET_PRODUCTS'
